export const DYNAMIC_FORGOT_PASSWORD = 'dynamic-forgot-password';
export const DEFAULT_FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD';
export const DEFAULT_VERIFICATION_QUESTION_FORM = 'VERIFICATION_QUESTION';
export const DEFAULT_CHANGE_PASSWORD_WITHOUT_OLD_FORM = 'CHANGE_PASSWORD_WITHOUT_OLD';
